import { titleCase } from '@efdigital/ll-addon-ui';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils.ts';
import type ProgramsProgramCohortRoute from '@efdigital/ll-admin-v2/routes/programs/program/cohort.ts';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import { pageTitle } from 'ember-page-title';

interface CohortSignature {
  Args: {
    model: ModelFrom<ProgramsProgramCohortRoute>;
    controller: unknown;
  };
}

const ProgramsProgramCohortTemplate: TemplateOnlyComponent<CohortSignature> =
  <template>
    {{pageTitle "Cohort"}}
    <div class="container pt-5">
      <div class="text-center px-xxl-5">
        <h2 class="display-6 mb-2">{{titleCase @model.cohort.title}}</h2>
        <p class="mb-4">
          <LinkTo
            class="btn btn-outline-dark border-0 btn-sm rounded-1"
            @route="programs.program.index"
            @models={{array @model.program_id}}
          >
            <iconify-icon inline icon="ph:arrow-left" />
            <strong>Program</strong>
            &ndash;
            {{@model.program.title}}
          </LinkTo>
        </p>
      </div>
    </div>

    <div class="container">
      <ul class="nav nav-tabs justify-content-center fw-bold">
        <li class="nav-item">
          <LinkTo
            class="nav-link"
            @route="programs.program.cohort.index"
            @models={{array @model.program_id @model.cohort_id}}
          >Details</LinkTo>
        </li>
        <li class="nav-item">
          <LinkTo
            class="nav-link"
            @route="programs.program.cohort.participants"
            @models={{array @model.program_id @model.cohort_id}}
          >Participants</LinkTo>
        </li>
        <li class="nav-item">
          <LinkTo
            class="nav-link"
            @route="programs.program.cohort.schedule"
            @models={{array @model.program_id @model.cohort_id}}
          >Schedule</LinkTo>
        </li>
        <li class="nav-item">
          <LinkTo
            class="nav-link"
            @route="programs.program.cohort.content"
            @models={{array @model.program_id @model.cohort_id}}
          >Content</LinkTo>
        </li>
        <li class="nav-item">
          <LinkTo
            class="nav-link"
            @route="programs.program.cohort.arrivals"
            @models={{array @model.program_id @model.cohort_id}}
          >Arrivals</LinkTo>
        </li>
        <li class="nav-item">
          <LinkTo
            class="nav-link"
            @route="programs.program.cohort.coaching"
            @models={{array @model.program_id @model.cohort_id}}
          >Coaching</LinkTo>
        </li>
      </ul>
    </div>

    {{outlet}}
  </template>;

export default ProgramsProgramCohortTemplate;
